import React from 'react'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'
import { sharedMessages as commonMessages } from '@Locales/index'
import styled from 'styled-components'
import Button from '@Components/Button'

type props = { joinNowURL?: string }

const Join: React.FC<props> = (props: props) => {
  const { joinNowURL } = props
  /*
  const renderSwitchStepButton = () => (
    <div style={{ fontSize: '12px' }}>
      <HubFormattedMessage {...messages.alreadyMember} />
      <StyledButtonLink>
        <HubFormattedMessage {...messages.signInHere} />
      </StyledButtonLink>
    </div>
  )
*/
  return (
    <JoinContainer>
      <JoinNowButton
        onClick={() => window && joinNowURL && (window.location.href = joinNowURL)}
        displayType="primary"
        id="__test__join__btn"
      >
        <HubFormattedMessage {...commonMessages.join} />
      </JoinNowButton>

      {/* {isEmailFormEnabled(partialHub) && this.renderSwitchStepButton()} */}
    </JoinContainer>
  )
}

export default Join

const JoinContainer = styled.div`
  width: 300px;
`

const JoinNowButton = styled(Button)`
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.fontSizeSmall};
  width: 100%;
  height: 44px;
  padding: 0 ${({ theme }) => theme.fontSizes.fontSizeSmall};
  margin: 15px 0;
  letter-spacing: 0.2px;
  border-radius: 2px;
  color: white;
  span {
    line-height: 44px;
  }
`
